var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
export const Title = (props) => {
    const { dataQa, title, style } = props, rest = __rest(props, ["dataQa", "title", "style"]);
    return (React.createElement(Grid, { container: true, spacing: 2, direction: "column" },
        React.createElement(Grid, { item: true },
            React.createElement(Box, { "data-qa": dataQa },
                React.createElement(Typography, Object.assign({}, rest, { sx: style }), title)))));
};
